import { render, staticRenderFns } from "./EmployeeInfo.vue?vue&type=template&id=0af06e09&scoped=true&"
import script from "./EmployeeInfo.vue?vue&type=script&lang=js&"
export * from "./EmployeeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af06e09",
  null
  
)

export default component.exports